import "./TournamentsDebugPanel.less";

import {useEffect, useState} from "preact/hooks";
import {Button, UIEvents} from "@dp-instant/ui";
import {CreateTournamentFormDebug} from "@game/ui/debug/tounaments/CreateTournamentFormDebug";
import {TypesCore, IEventEmitter} from "@dp-instant/interfaces";
import {di} from "@dp-instant/core";
import {ShareTournamentFormDebug} from "@game/ui/debug/tounaments/ShareTournamentFormDebug";

export const TournamentsDebugPanel = () => {
    const [state, setState] = useState<{tournaments: any[]}>({tournaments: []});
    const close = () =>
        di.get<IEventEmitter>(TypesCore.dispatcher).emit(UIEvents.POPUP, {id: null});

    useEffect(() => {
        window.FBInstant.tournament.getTournamentsAsync().then((tournaments: any) => {
            setState({tournaments});
        });
    }, []);

    return (
        <div
            className="popups"
            style={{
                width: "100%",
                height: "100%",
                paddingTop: "20px",
                background: "rgba(black, 0.5)"
            }}
        >
            <div class={"debug-tournaments-popup"}>
                Tournaments
                <ul>
                    {state.tournaments.map(t => (
                        <li>
                            {`${t.getID()} ${t.getTitle()}`}
                            <a
                                href="#"
                                onClick={() => {
                                    window.FBInstant.tournament
                                        .joinAsync("" + t.getID())
                                        .then(() => {
                                            debugger;
                                        });
                                }}
                            >
                                Join
                            </a>
                        </li>
                    ))}
                </ul>
                {/*<Button onClick={() => }>Update Current Tournament</Button>*/}
                <br />
                <hr />
                <CreateTournamentFormDebug />
                <hr />
                <ShareTournamentFormDebug />
                <br />
                <Button onClick={close}>Close</Button>
            </div>
        </div>
    );
};
